import { JWT_TOKEN_URL_PROD, JWT_TOKEN_URL_STAGE, CLIENT_ID_PROD, CLIENT_ID_STAGE } from '../const';
export var getJwtFromId = function (isProd) {
    var url = isProd ? JWT_TOKEN_URL_PROD : JWT_TOKEN_URL_STAGE;
    var clientId = isProd ? CLIENT_ID_PROD : CLIENT_ID_STAGE;
    var jwtUrl = "".concat(url, "?client_id=").concat(clientId);
    return fetch(jwtUrl, { credentials: 'include', method: 'POST' })
        .then(function (res) { return res.json(); });
};
//# sourceMappingURL=getJwtFromId.js.map